.formItem {
  margin: 1em 0;

  & input.error {
    box-shadow: 0 0 1em var(--red);
  }
}

.fontSizeAndNoMargin {
  margin-bottom: 0;
  font-size: 0.875rem;
}
